
/// <amd-module name="Search/Shared/CustomerIntelligenceConstants" />
export const SEARCH_AREA = "SearchPortal";
